(function () {
  'use strict';

  angular
      .module('tfc.Reports')
      .controller('AllReportsCtrl', AllReportsCtrl);

  // @ngInject
  function AllReportsCtrl($state, reports, ReportCategories, ReportUtil) {
    var vm = this;

    vm.fileType = ReportUtil.fileType;
    vm.reportIcon = ReportUtil.reportIcon;
    vm.downloadReport = ReportUtil.downloadReport;
    vm.openReport = function (report) {
      if (report.isShowMore) {
        $state.go('reportList.' + report.category);
      } else {
        ReportUtil.openReport(report);
      }
    };

    var showMores = _.reduce(ReportCategories, function (map, cat) {
      // include isActive so it's not filtered out from the ng-repeat
      map[cat] = { isShowMore : true, category : cat, isActive : true };
      return map;
    }, {});

    vm.categories = ReportCategories;
    var reportMap = _.groupBy(_.filter(reports, 'isActive'), 'key.category');

    vm.showCategory = function (category) {
      return !!reportMap[category];
    };

    vm.getReports = function (category) {
      var reports = ReportUtil.sort(reportMap[category]);
      if (reports.length > 4) {
        reports = reports.slice(0, 3).concat(showMores[category]);
      }
      return reports;
    };

  }

})();
